import React, { useEffect } from "react";
import utils from "../../../../../utils";
import Context from "../../../../../context";
import dictionary from "../../../../../dictionary";

import {
  CustomModal,
  CustomView,
  PlateNumber,
  UserInformation,
} from "../../../../../components";
import {
  ICityItem,
  IProvinceItem,
} from "../../../../../types/common.interface";
import { useQuery } from "react-query";
import api from "../../../../../api";
import values from "../../../../../values";
import ImageViewer from "../../../../../components/ImageViewer";
import TitleLine from "../../../../../components/TitleLine";
import { useTranslation } from "react-i18next";

const DriverInformation = () => {
  const { showModal, setShowModal, selectedDriver } = React.useContext(
    Context.DriverScreen
  );
  const [selectedCity, setSelectedCity] = React.useState<ICityItem>();
  const [selectedProvince, setSelectedProvince] =
    React.useState<IProvinceItem>();

  // !! ===========================================================================================================
  // !!                                            Start API Call
  // !! -----------------------------------------------------------------------------------------------------------
  const getAllProvince = useQuery([values.useQueryKeys.getAllProvince], () =>
    api.get.common.getAllProvince()
  );
  const getAllCity = useQuery(
    [values.useQueryKeys.getAllCity, selectedProvince],
    () =>
      api.get.common.getAllCity({
        provinceCode: selectedProvince
          ? selectedProvince?.Code
          : getAllProvince?.data?.result?.find(
              (item: IProvinceItem) =>
                item?._id === selectedDriver?.schoolDriverInformation?.province
            ).Code,
      })
  );

  useEffect(() => {
    setSelectedProvince(
      getAllProvince?.data?.result?.find(
        (item: IProvinceItem) =>
          item?._id === selectedDriver?.schoolDriverInformation?.province
      )
    );
    setSelectedCity(
      getAllCity?.data?.result?.find(
        (item: ICityItem) =>
          item?._id === selectedDriver?.schoolDriverInformation?.city
      )
    );
  }, [selectedDriver, getAllProvince?.data?.result, getAllCity?.data?.result]);

  const { t } = useTranslation();

  return (
    <section id="service-screen-show-user-information">
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        minWidth={"50vw"}
        maxWidth={"55vw"}
        open={showModal === "SHOW_DRIVER_INFORMATION"}
        overlayClose
      >
        <CustomView.Container className="scroll-content">
          <UserInformation
            avatar={selectedDriver?.avatar}
            name={
              selectedDriver?.firstName
                ? selectedDriver?.firstName
                : selectedDriver?.name
            }
            lastName={selectedDriver?.lastName ? selectedDriver?.lastName : ""}
            phoneNumber={
              selectedDriver?.phoneNumber
                ? selectedDriver?.phoneNumber
                : selectedDriver?.telephone
            }
            isBlock={null}
          />
          <hr />
          <CustomView.Row className="form-column-row">
            {selectedDriver?.schoolDriverInformation?.province && (
              <CustomView.Column
                small={12}
                medium={5}
                extraLarge={3}
                className="form-values form-column"
              >
                <label className="form-label">{t("province")} :</label>
                <p>{selectedProvince?.Name}</p>
              </CustomView.Column>
            )}
            {selectedDriver?.schoolDriverInformation?.city && (
              <CustomView.Column
                medium={5}
                small={12}
                extraLarge={3}
                className="form-values form-column"
              >
                <label className="form-label">{t("city")} :</label>
                <p>{selectedCity?.Name}</p>
              </CustomView.Column>
            )}
            {selectedDriver?.gender && (
              <CustomView.Column
                medium={5}
                small={12}
                extraLarge={3}
                className="form-values form-column"
              >
                <label className="form-label">{t("gender")} :</label>
                <p>
                  {dictionary.genderEnglish2Persian(selectedDriver?.gender)}
                </p>
              </CustomView.Column>
            )}
            {selectedDriver?.driverInformation?.carBrand && (
              <CustomView.Column
                medium={5}
                small={12}
                extraLarge={3}
                className="form-values form-column"
              >
                <label className="form-label">{t("carBrand")}:</label>
                <p>{selectedDriver?.driverInformation?.carBrand}</p>
              </CustomView.Column>
            )}
            {selectedDriver?.driverInformation?.carColor && (
              <CustomView.Column
                medium={5}
                small={12}
                extraLarge={3}
                className="form-values form-column"
              >
                <label className="form-label">{t("carColor")}:</label>
                <p>{selectedDriver?.driverInformation?.carColor}</p>
              </CustomView.Column>
            )}
            {selectedDriver?.driverInformation?.carModel && (
              <CustomView.Column
                medium={5}
                small={12}
                extraLarge={3}
                className="form-values form-column"
              >
                <label className="form-label">{t("carProduce")}:</label>
                <p>{selectedDriver?.driverInformation?.carModel}</p>
              </CustomView.Column>
            )}
            {selectedDriver?.driverInformation?.carSystem && (
              <CustomView.Column
                medium={5}
                small={12}
                extraLarge={3}
                className="form-values form-column"
              >
                <label className="form-label">{t("carSystem")}:</label>
                <p>{selectedDriver?.driverInformation?.carSystem}</p>
              </CustomView.Column>
            )}
            {selectedDriver?.driverInformation?.driverLicenseNumber && (
              <CustomView.Column
                medium={5}
                small={12}
                extraLarge={3}
                className="form-values form-column"
              >
                <label className="form-label">{t("licenceNumber")}:</label>
                <p>{selectedDriver?.driverInformation?.driverLicenseNumber}</p>
              </CustomView.Column>
            )}
            {selectedDriver?.driverInformation?.insuranceExpiryDate && (
              <CustomView.Column
                medium={5}
                small={12}
                extraLarge={3}
                className="form-values form-column"
              >
                <label className="form-label">{t("insuranceExpire")}:</label>
                <p>
                  {utils.convertGregorianToJalali({
                    date: selectedDriver?.insuranceExpiryDate,
                    format: "jYYYY/jMM/jDD",
                  })}
                </p>
              </CustomView.Column>
            )}
            {selectedDriver?.driverInformation?.insuranceNumber && (
              <CustomView.Column
                medium={5}
                small={12}
                extraLarge={3}
                className="form-values form-column"
              >
                <label className="form-label">{t("insuranceNumber")}:</label>
                <p>{selectedDriver?.driverInformation?.insuranceNumber}</p>
              </CustomView.Column>
            )}
            {selectedDriver?.driverInformation?.nationalCode && (
              <CustomView.Column
                medium={5}
                small={12}
                extraLarge={3}
                className="form-values form-column"
              >
                <label className="form-label">{t("nationalCode")}:</label>
                <p>{selectedDriver?.driverInformation?.nationalCode}</p>
              </CustomView.Column>
            )}
            {selectedDriver?.driverInformation
              ?.uniqueCodeThirdPartyInsurance && (
              <CustomView.Column
                medium={5}
                small={12}
                extraLarge={3}
                className="form-values form-column"
              >
                <label className="form-label">
                  {t("insuranceUniqueCode")}:
                </label>
                <p>
                  {
                    selectedDriver?.driverInformation
                      ?.uniqueCodeThirdPartyInsurance
                  }
                </p>
              </CustomView.Column>
            )}
            {selectedDriver?.financial?.kartNumber && (
              <CustomView.Column
                medium={5}
                small={12}
                extraLarge={3}
                className="form-values form-column"
              >
                <label className="form-label">{t("cardNumber")} :</label>
                <p>{selectedDriver?.financial?.kartNumber}</p>
              </CustomView.Column>
            )}
            {selectedDriver?.financial?.shabaNumber && (
              <CustomView.Column
                medium={5}
                small={12}
                extraLarge={3}
                className="form-values form-column"
              >
                <label className="form-label">{t("shabaNumber")} :</label>
                <p>{selectedDriver?.financial?.shabaNumber}</p>
              </CustomView.Column>
            )}
            {selectedDriver?.driverInformation?.vin && (
              <CustomView.Column
                medium={5}
                small={12}
                extraLarge={3}
                className="form-values form-column"
              >
                <label className="form-label">{t("vin")}:</label>
                <p>{selectedDriver?.driverInformation?.vin}</p>
              </CustomView.Column>
            )}
            {selectedDriver?.driverInformation?.plateNumber && (
              <CustomView.Column
                medium={5}
                small={12}
                extraLarge={3}
                className="form-values form-column"
              >
                <label className="form-label">{t("plateNumber")} :</label>
                <PlateNumber
                  tagNum={selectedDriver?.driverInformation?.plateNumber}
                  editor={false}
                  onChange={() => true}
                />
              </CustomView.Column>
            )}{" "}
          </CustomView.Row>
          {selectedDriver?.schoolDriverInformation?.documents && (
            <CustomView.Row className="form-column-row">
              <div style={{ marginTop: "1rem" }}>
                <TitleLine title={t("driverDocs")} />
              </div>
              {selectedDriver?.schoolDriverInformation?.documents
                ?.nationalCardFront && (
                <CustomView.Column
                  medium={3}
                  className="form-documents form-column"
                >
                  <label className="form-label">
                    {t("nationalCardFrontImage")}
                  </label>
                  <ImageViewer
                    imageUrl={
                      selectedDriver?.schoolDriverInformation?.documents
                        ?.nationalCardFront
                    }
                  />
                </CustomView.Column>
              )}
              {selectedDriver?.schoolDriverInformation?.documents
                ?.nationalCardBack && (
                <CustomView.Column
                  medium={3}
                  className="form-documents form-column"
                >
                  <label className="form-label">
                    {t("nationalCardBackImage")}
                  </label>
                  <ImageViewer
                    imageUrl={
                      selectedDriver?.schoolDriverInformation?.documents
                        ?.nationalCardBack
                    }
                  />
                </CustomView.Column>
              )}{" "}
              {selectedDriver?.schoolDriverInformation?.documents
                ?.carCardFront && (
                <CustomView.Column
                  medium={3}
                  className="form-documents form-column"
                >
                  <label className="form-label">{t("carCardFrontImage")}</label>
                  <ImageViewer
                    imageUrl={
                      selectedDriver?.schoolDriverInformation?.documents
                        ?.carCardFront
                    }
                  />
                </CustomView.Column>
              )}{" "}
              {selectedDriver?.schoolDriverInformation?.documents
                ?.carCardBack && (
                <CustomView.Column
                  medium={3}
                  className="form-documents form-column"
                >
                  <label className="form-label">{t("carCardBackImage")}</label>
                  <ImageViewer
                    imageUrl={
                      selectedDriver?.schoolDriverInformation?.documents
                        ?.carCardBack
                    }
                  />
                </CustomView.Column>
              )}
              {selectedDriver?.schoolDriverInformation?.documents
                ?.insurance && (
                <CustomView.Column
                  medium={3}
                  className="form-documents form-column"
                >
                  <label className="form-label">{t("insuranceImage")}</label>
                  <ImageViewer
                    imageUrl={
                      selectedDriver?.schoolDriverInformation?.documents
                        ?.insurance
                    }
                  />
                </CustomView.Column>
              )}{" "}
              {selectedDriver?.schoolDriverInformation?.documents
                ?.checkBackground && (
                <CustomView.Column
                  medium={3}
                  className="form-documents form-column"
                >
                  <label className="form-label">
                    {t("backBackgroundImage")}
                  </label>
                  <ImageViewer
                    imageUrl={
                      selectedDriver?.schoolDriverInformation?.documents
                        ?.checkBackground
                    }
                  />
                </CustomView.Column>
              )}{" "}
              {selectedDriver?.schoolDriverInformation?.documents
                ?.driverLicence && (
                <CustomView.Column
                  medium={3}
                  className="form-documents form-column"
                >
                  <label className="form-label">{t("driverLicence")}</label>
                  <ImageViewer
                    imageUrl={
                      selectedDriver?.schoolDriverInformation?.documents
                        ?.driverLicence
                    }
                  />
                </CustomView.Column>
              )}
            </CustomView.Row>
          )}
        </CustomView.Container>
      </CustomModal>
    </section>
  );
};

export default DriverInformation;
